import { Component, OnInit } from '@angular/core';
import { icon, latLng, marker, polyline, tileLayer } from 'leaflet';
import { HttpService } from '../../../http.service';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
declare var google: any;
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  providers: [DatePipe]

})
export class ContactComponent implements OnInit {
 
	contactUsForm : FormGroup;
	isSubmitted  =  false;
	contactSpin  =  0;
	contactUsFormMessage  = "";
    locationsMarkers :any =[];
	
	constructor(
	private _http: HttpService, 
	private datePipe : DatePipe,	
	private formBuilder: FormBuilder) { }
  
	francaisList:any = [];
	currentTime: Date | undefined = new Date();

	ngOnInit(): void {
		this.getFrancaisList();
		this.contactUsForm  =  this.formBuilder.group({
			email: ['', [Validators.required]],
			fullname: ['', Validators.required],
			lastname: ['', Validators.required],
			subject: ['', Validators.required],
			message: ['', Validators.required],
		});
	}
	drawMap () {
		var map2 = this.create_map(new google.maps.LatLng(41.8781136,-87.62979819999998));
		var infoWindow = new google.maps.InfoWindow();
		var bounds = new google.maps.LatLngBounds();

		for(var i=0;i<this.francaisList.length; i++) {
			console.log(this.francaisList[i]);
			const marker = new google.maps.Marker({
				  position: new google.maps.LatLng(parseFloat(this.francaisList[i].lat),parseFloat(this.francaisList[i].lng)),
				  map: map2,
				
				});
			bounds.extend(marker.position);
	
			var storeName = this.francaisList[i].name;	
			google.maps.event.addListener(marker, 'click', (function (marker, i, storeName) {
				  console.log(storeName);
				  return function () {
					const content = `
					  <h4>Store: ${storeName}</h4>
					`;
					infoWindow.setContent(content);
					infoWindow.open(map2, marker);
				  }
				})(marker, i, storeName));

		}
		map2.fitBounds(bounds);

	}
	getFrancaisList()
	{
	var token=localStorage.getItem('jwt_token');
	var currenTime='';
	if(localStorage.getItem('orderDatetime')!=null){
		currenTime=this.datePipe.transform(localStorage.getItem('orderDatetime'), 'H:mm');
	}else{
		currenTime=this.datePipe.transform(this.currentTime, 'H:mm');
	}
	this._http.getRequest('get_francaislist.php?res_id=49&user_current_hour='+currenTime,token).subscribe((data:any) => {
		if(data.data.francais_data){
			this.francaisList=data.data.francais_data;
			this.drawMap();
		} 
		
		}
	);
  }
	get formControls() { return this.contactUsForm.controls; }

	//are used to insert 
	contactUsFormAdd () {
		this.contactUsFormMessage = "";

		this.isSubmitted = true;
		if(this.contactUsForm.invalid){
		  return;
		}
		this.contactSpin = 1;
		this.contactUsFormMessage = "";
		const contactData = new FormData();
		contactData.append( 'message', this.contactUsForm.value.message );
		contactData.append( 'subject', this.contactUsForm.value.subject );
		contactData.append( 'lastname', this.contactUsForm.value.lastname );
		contactData.append( 'fullname', this.contactUsForm.value.fullname );
		contactData.append( 'email', this.contactUsForm.value.email );
		this._http.postRequest('contact_us.php',contactData).subscribe((response : any)=>{
			this.contactSpin=0;
			this.contactUsFormMessage="We have recived your email. We will get back to you.";
		}); 
	}
	create_map(center){
	  return new google.maps.Map(document.getElementById('map'),{
		//center: center,
		zoom:8,
		zoomControlOptions: {
		  position: google.maps.ControlPosition.RIGHT_CENTER
		},
		streetViewControlOptions: {
		  position: google.maps.ControlPosition.RIGHT_CENTER
		}
	  });
	}
}
